<h3 class="card-title">{{ 'agreements.data' | translate }}</h3>

@if (isDeletedByOwner && !canDisplayData) {
  <div class="deleted">
    {{ 'agreement.deleted.data' | translate }}
  </div>
}
@if (
  ((language$ | async)?.items?.length || 0) > 0 &&
  agreementProperties &&
  agreementProperties.length > 0
) {
  <div>
    @for (item of (language$ | async)?.items; track item.orderIndex) {
      @switch (item.type) {
        @case ('PROPERTY') {
          @if (
            (hasSteps$ | async) === false &&
            (getAgreementPropertyForItem(item)?.property | propertyHasValue)
          ) {
            <ax-agreement-property-view
              [proposal]="proposal"
              [agreementProperty]="getAgreementPropertyForItem(item)"
              [property]="getPropertyForItem(item)"
              [language]="language"
              [myProfile]="myProfile"
              [showOutOfSync]="showOutOfSync"
              [agreementActive]="agreementActive"
              [agreementConfirmed]="agreementConfirmed"
              (addProperty)="addProperty.next($event)"
              (editProperty)="editProperty.next($event)"
            ></ax-agreement-property-view>
          }
        }

        @case ('TEMPLATE') {
          <ax-agreement-template-view
            [proposal]="proposal"
            [language]="language"
            [item]="item"
            [agreementProperties]="agreementProperties"
          ></ax-agreement-template-view>
        }

        @default {
          <ax-agreement-step-view
            *ngIf="!stepSkipped(item)"
            [proposal]="proposal"
            [item]="item"
            [step]="getStepForItem(item)"
            [agreementProperties]="agreementProperties"
            [language]="(language$ | async) || undefined"
            [myProfile]="myProfile"
            [showOutOfSync]="showOutOfSync"
            [agreementActive]="agreementActive"
            [agreementConfirmed]="agreementConfirmed"
            (addProperty)="addProperty.next($event)"
            (editProperty)="editProperty.next($event)"
          ></ax-agreement-step-view>
        }
      }
    }
  </div>
}
@if (
  ((agreementDocuments && agreementDocuments.length) || language?.documents?.length) &&
  !isDeletedByOwner
) {
  <ax-agreement-documents
    [isInAgreement]="isInAgreement"
    [agreementDocuments]="agreementDocuments"
    [language]="language || undefined"
    [accepted]="agreementConfirmed"
  ></ax-agreement-documents>
}
